import React from "react";
import { Dot } from "lucide-react";

const DotSeparator: React.FC<{ size?: number }> = ({ size = 16 }) => (
  <span className="dot">
    <Dot size={size} />
  </span>
);

export default DotSeparator;
